import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.25 9a.75.75 0 1 1-1.5 0zm1.085 6.175a.75.75 0 0 1 1.053-1.069zM3.26 10.752l.532.53a.75.75 0 0 1-1.183-.157zm1.695-2.77A.75.75 0 1 1 6.018 9.04L4.954 7.983Zm-3.916.401a.75.75 0 1 1 1.301-.745zM11.417 9v.75a.75.75 0 0 1-.75-.747zm3.505-.75a.75.75 0 1 1 0 1.5zm-4.275-3.634a.75.75 0 0 1 1.5-.007zm.77 11.55A7.167 7.167 0 0 0 18.583 9h1.5a8.667 8.667 0 0 1-8.666 8.667v-1.5ZM18.583 9a7.167 7.167 0 0 0-7.166-7.167v-1.5A8.667 8.667 0 0 1 20.083 9zm-7.166-7.167A7.167 7.167 0 0 0 4.25 9h-1.5A8.667 8.667 0 0 1 11.417.333zm-5.03 12.273a7.14 7.14 0 0 0 5.03 2.06v1.5a8.64 8.64 0 0 1-6.082-2.491zm-3.66-3.882 2.227-2.241L6.018 9.04l-2.227 2.24-1.064-1.057Zm-.12.901-1.57-2.742 1.302-.745 1.57 2.742zm8.81-2.875h3.505v1.5h-3.505zm.73-3.641.02 4.388-1.5.006-.02-4.387z"
    }, null, -1)
  ]))]))
}
export default { render: render }